export const transitions = {
    duration: {
        shortest: '0.0s',
        default: '0.3s',
    },
};
//# sourceMappingURL=transitions.js.map